import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../web/components-v2/Theme/theme';

const monoFontStack = "'SF Mono', 'Monaco', 'Menlo', 'Courier New', monospace";

export const styleSheet = StyleSheet.create({
	container: {
		padding: `${THEME.spacing.lg}px ${THEME.spacing.xl}px ${THEME.spacing.xl}px`,
		maxWidth: 550,
	},
	title: {
		fontSize: THEME.typography.fontSizes.lg,
		fontWeight: THEME.typography.fontWeights.bold,
		marginBottom: THEME.spacing.md,
		display: 'flex',
		alignItems: 'center',
		gap: THEME.spacing.sm,
	},
	titleIcon: {
		flexShrink: 0,
	},
	titleSuccess: {
		color: THEME.colors.success.main,
	},
	titleWarning: {
		color: THEME.colors.text.main,
	},
	titleError: {
		color: THEME.colors.danger.main,
	},
	summaryList: {
		listStyleType: 'none',
		padding: 0,
		margin: `0 0 ${THEME.spacing.md}px`,
	},
	summaryItem: {
		fontSize: THEME.typography.fontSizes.sm,
		color: THEME.colors.text.main,
		padding: `${THEME.spacing.xs}px 0`,
	},
	summaryCount: {
		fontWeight: THEME.typography.fontWeights.bold,
		marginRight: 6,
		display: 'inline-block',
		minWidth: 30,
		textAlign: 'right' as const,
	},
	emptyFallback: {
		fontSize: THEME.typography.fontSizes.sm,
		color: THEME.colors.text.main,
		marginBottom: THEME.spacing.md,
	},
	warningsSection: {
		background: THEME.colors.warning.light,
		border: `1px solid ${THEME.colors.warning.dark}`,
		borderRadius: THEME.common.borderRadius,
		padding: `12px ${THEME.spacing.md}px`,
		marginBottom: THEME.spacing.md,
	},
	warningsTitle: {
		fontSize: THEME.typography.fontSizes.sm,
		fontWeight: THEME.typography.fontWeights.bold,
		color: THEME.colors.text.main,
		marginBottom: THEME.spacing.sm,
	},
	warningItem: {
		fontSize: THEME.typography.fontSizes.xs,
		color: THEME.colors.text.main,
		marginBottom: THEME.spacing.sm,
	},
	warningContactList: {
		listStyleType: 'none',
		padding: `${THEME.spacing.xs}px 0 0 12px`,
		margin: 0,
		maxHeight: 200,
		overflowY: 'auto',
	},
	warningContactId: {
		fontSize: THEME.typography.fontSizes.xs,
		fontFamily: monoFontStack,
		padding: '2px 0',
	},
	skippedContact: {
		fontSize: THEME.typography.fontSizes.xs,
		color: THEME.colors.text.main,
		padding: '6px 0',
		borderBottom: `1px solid ${THEME.colors.border.light}`,
		':last-child': {
			borderBottom: 'none',
		},
	},
	skippedContactName: {
		fontWeight: THEME.typography.fontWeights.bold,
	},
	skippedContactTitle: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.xs,
	},
	skippedContactEmail: {
		fontSize: THEME.typography.fontSizes.xs,
		color: THEME.colors.text.light,
		marginTop: 2,
		fontFamily: monoFontStack,
		overflowWrap: 'break-word' as const,
	},
	mergeNote: {
		fontSize: THEME.typography.fontSizes.xs,
		fontStyle: 'italic',
		color: THEME.colors.text.main,
		marginTop: THEME.spacing.md,
	},
	errorSection: {
		background: THEME.colors.danger.light,
		border: `1px solid ${THEME.colors.danger.main}`,
		borderRadius: THEME.common.borderRadius,
		padding: `12px ${THEME.spacing.md}px`,
		marginBottom: THEME.spacing.md,
	},
	errorMessage: {
		fontSize: THEME.typography.fontSizes.sm,
		color: THEME.colors.danger.main,
		overflowWrap: 'break-word',
	},
	footer: {
		display: 'flex',
		justifyContent: 'flex-end',
		marginTop: THEME.spacing.lg,
	},
});
